import { Card, Flex, Space, Typography } from 'antd'
import Tenant from '../../../../modules/tenant/Tenant'
import { Iphone } from '../../../Iphone/Iphone'

const { Text } = Typography

interface Props {
  title: string
  subtitle: string
  body: string
}

export const IphoneModule = ({ title, subtitle, body }: Props) => {
  return (
    <Iphone>
      <Flex justify="center" align="center" style={{ height: '100%' }}>
        <Flex style={{ width: '100%', padding: 20 }}>
          <Card
            style={{
              width: '100%',
              background: '#00000055',
              border: '0',
            }}
            styles={{ body: { padding: 10 } }}
          >
            <Flex justify="space-between" align="center" gap={10}>
              <Space>
                <Tenant.Avatar shape="square" size={35} />
              </Space>
              <Space className="w-full" orientation="vertical" size={0}>
                <Text
                  className="m-0"
                  style={{
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: 12,

                    padding: 0,
                  }}
                >
                  {title}
                </Text>
                <Text
                  className="m-0"
                  style={{
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: 12,

                    padding: 0,
                  }}
                >
                  {subtitle}
                </Text>
                <Text
                  className="m-0"
                  style={{
                    color: '#fff',
                    fontSize: 12,
                    padding: 0,
                  }}
                >
                  {body}
                </Text>
              </Space>
            </Flex>
          </Card>
        </Flex>
      </Flex>
    </Iphone>
  )
}
